import React from 'react';
import './Spinner.css'

const Spinner = () => (
    <div className="text-center loader"></div>
)

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.js